import { Circle, G, Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const Dumpster: React.FC<Props> = ({ fill }) => {
    return (
        <Svg
            fill={fill}
            id="Capa_1"
            enable-background="new 0 0 512 512"
            height="100%"
            width={"12pt"}
            viewBox="0 0 512 512"
        >
            <G>
                <G>
                    <Path d="m0 167.119v-60.119h512v59.996z" />
                </G>
                <Path d="m66.73 32h114.27v45h-136.77z" />
                <Path d="m467.77 77h-136.77v-45h114.27z" />
                <G>
                    <Path d="m181 197.08v254.92h-118.43l-28.32-254.89z" />
                    <Path d="m301 197.05v254.95h-90v-254.93z" />
                    <Path d="m477.76 197.01-28.33 254.99h-118.43v-254.96z" />
                </G>
                <G>
                    <Circle cx="421" cy="482" r="30" />
                </G>
                <G>
                    <Circle cx="91" cy="482" r="30" />
                </G>
                <Path d="m211 0h90v77h-90z" />
            </G>
        </Svg>
    );
};

export default Dumpster;
